(function () {
  var card = document.getElementById('hs-card');
  var form = document.getElementById('hs-form');
  if (!card) return;
  var STATUS = '/apps/atari-birthday/holiday/status', SUBMIT = '/apps/atari-birthday/holiday/submit';
  var started = Date.now();

  function panel(heading, text) {
    card.innerHTML = '<h1 class="hs__heading"></h1><p class="hs__sub"></p><a class="hs__btn hs__btn--ghost" href="/">Back to Atari</a>';
    card.querySelector('.hs__heading').textContent = heading;
    card.querySelector('.hs__sub').textContent = text;
    card.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Live state from the worker: catches a closed survey and a page cached before the customer answered.
  fetch(STATUS).then(function (r) { return r.json(); }).then(function (s) {
    if (!s) return;
    if (s.completed && form) panel('Thanks, we have your answers', 'You have already completed the holiday survey. Your Atari Club points are in your account.');
    else if (s.open === false) panel('The holiday survey has closed', 'Thanks for your interest. This survey is no longer accepting responses.');
  }).catch(function () {});

  if (!form) return;
  var msg = document.getElementById('hs-msg'), btn = document.getElementById('hs-submit');
  function say(text, kind) { msg.textContent = text || ''; msg.className = 'hs__msg' + (kind ? ' hs__msg--' + kind : ''); }

  // "Pick your top 2": once two are chosen, the rest lock until one is cleared.
  form.querySelectorAll('.hs-q[data-type="multi2"]').forEach(function (q) {
    var boxes = q.querySelectorAll('input[type=checkbox]');
    q.addEventListener('change', function () {
      var n = q.querySelectorAll('input:checked').length;
      boxes.forEach(function (b) { b.disabled = n >= 2 && !b.checked; });
    });
  });
  function clearError(e) {
    var q = e.target.closest ? e.target.closest('.hs-q') : null;
    if (q) q.classList.remove('hs-q--error');
  }
  form.addEventListener('change', clearError);
  form.addEventListener('input', clearError);

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var answers = {}, firstMissing = null;
    form.querySelectorAll('.hs-q').forEach(function (q) {
      var id = q.getAttribute('data-q'), type = q.getAttribute('data-type'), val;
      if (type === 'text') {
        val = (q.querySelector('textarea').value || '').trim();
        if (val) answers[id] = val;
        else if (q.getAttribute('data-required')) { q.classList.add('hs-q--error'); firstMissing = firstMissing || q; }
        return;
      }
      var picked = Array.prototype.map.call(q.querySelectorAll('input:checked'), function (i) { return i.value; });
      if (!picked.length) { q.classList.add('hs-q--error'); firstMissing = firstMissing || q; return; }
      answers[id] = type === 'single' ? picked[0] : (type === 'scale' ? parseInt(picked[0], 10) : picked);
    });
    if (firstMissing) { say('Please answer the highlighted questions.', 'error'); firstMissing.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }

    btn.disabled = true; say('Sending your answers…');
    fetch(SUBMIT, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ answers: answers, duration_seconds: Math.round((Date.now() - started) / 1000), website: (document.getElementById('hs-hp') || {}).value || '' })
    }).then(function (r) { return r.json(); }).then(function (d) {
      d = d || {};
      if (d.ok) {
        if (d.already_submitted) return panel('Thanks, we have your answers', 'You have already completed the holiday survey.');
        return panel('Thank you!', d.points_granted
          ? 'Your answers are in, and 250 Atari Club points have been added to your account.'
          : 'Your answers are in. Your 250 Atari Club points will be added to your account shortly.');
      }
      btn.disabled = false;
      say(({
        not_logged_in: 'Please log in first, then try again.',
        bad_signature: 'We could not verify your session. Please refresh and try again.',
        rate_limited: 'One moment, please try again in a minute.',
        closed: 'This survey has closed and is no longer accepting responses.',
        customer_not_found: 'We could not find your account. Please refresh and try again.'
      })[d.error] || (/^missing_/.test(d.error || '') ? 'Please answer every required question, then submit again.' : 'Sorry, something went wrong. Please try again.'), 'error');
    }).catch(function () { btn.disabled = false; say('Network error. Please try again.', 'error'); });
  });
})();
